import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import store from 'dashboard/store';

const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');

const beforeEnter = (to, from, next) => {
  const isEnabled = store.getters['accounts/isFeatureEnabledonAccount'](
    to.params.accountId,
    FEATURE_FLAGS.SCHEDULE
  );

  if (!isEnabled) {
    // Em navegação direta (bookmark/link), from é START_LOCATION (name undefined
    // e fullPath "/"), então voltar para from.fullPath deixaria o usuário em "/".
    return next(
      from.name
        ? from.fullPath
        : frontendURL(`accounts/${to.params.accountId}/dashboard`)
    );
  }

  return next();
};

export default {
  routes: [
    {
      path: frontendURL(
        'accounts/:accountId/settings/custom-reminder-messages'
      ),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsContent,
      beforeEnter,
      props: {
        headerTitle: 'CUSTOM_MESSAGES_MGMT.PAGE_TITLE',
        icon: 'add-alert',
      },
      children: [
        {
          path: '',
          name: 'custom_reminder_messages',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
